/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Optional_AddonInputs */



/**
* | output |
* | --- |
* | "Optional add-on" |
*
* @param {Signup_Compare_Optional_AddonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_optional_addon = /** @type {((inputs?: Signup_Compare_Optional_AddonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Optional_AddonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Optional add-on")
	if (locale === "de") return /** @type {LocalizedString} */ ("Optional add-on")
	if (locale === "it") return /** @type {LocalizedString} */ ("Optional add-on")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Optional add-on")
	if (locale === "es") return /** @type {LocalizedString} */ ("Optional add-on")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Optional add-on")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Optional add-on")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Optional add-on")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Optional add-on")
	return /** @type {LocalizedString} */ ("Optional add-on")
});